import React, { createContext, useContext } from 'react';

// A tiny history router and the signed-in person's context, shared by every page.
export const RouterCtx = createContext(null);
export const useRouter = () => useContext(RouterCtx);
export function navigate(to) { window.history.pushState({}, '', to); window.dispatchEvent(new PopStateEvent('popstate')); }
export function Link({ to, children, className, ...rest }) {
  const { path } = useRouter();
  const active = to === '/' ? path === '/' : path.startsWith(to) && (to !== '/admin' || path === '/admin');
  return <a href={to} className={[className, active ? 'active' : ''].filter(Boolean).join(' ')} onClick={e => { if (!e.metaKey && !e.ctrlKey) { e.preventDefault(); navigate(to); } }} {...rest}>{children}</a>;
}

export const MeCtx = createContext(null);
export const useMe = () => useContext(MeCtx);
